import { Country, country } from '@app/models/agency';
import { DictionaryEntity } from '@app/pcs/models/dictionary-entity';
import { TypeOfLoco } from '@app/pcs/models/type-of-loco';
import { gql } from 'apollo-angular';

export interface LocoTypeNumber {
  locoNumber?: string;
  typeOfLoco?: DictionaryEntity<TypeOfLoco>;
  country?: Country;
  seriesNumber?: string;
  serialNumber?: string;
}

export const locoTypeNumberDetailed = gql`
  fragment locoTypeNumberDetailed on LocoTypeNumber {
    locoNumber
    typeOfLoco {
      id
      description
    }
    country {
      ...country
    }
    seriesNumber
    serialNumber
  }
  ${country}
`;
